import React from "react";

const Message = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M9.128 27.798L2 33.222V4.55c0-.411.169-.805.469-1.096.3-.29.707-.454 1.131-.454h28.8c.424 0 .831.163 1.131.454.3.29.469.685.469 1.096v21.698c0 .41-.169.805-.469 1.096-.3.29-.707.454-1.131.454H9.128zM10 13.849v3.1h3.2v-3.1H10zm6.4 0v3.1h3.2v-3.1h-3.2zm6.4 0v3.1H26v-3.1h-3.2z"
          fill={fill}
      />
    </svg>
);

export default Message;
